import React from 'react';
import { LoadingSpinner } from 'views/MassiveResults/LoadingComponent';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap'
import { useSendOmLetter } from 'hooks/useSendOmLetter/useSendOmLetter';
import EmailInput from 'components/EmailInput/EmailInput';
import { ErrorDialog } from 'components/ErrorDialog/ErrorDialog';
import { SuccessDialog } from 'components/SuccessDialog/SuccessDialog';
import { Upload } from 'react-bootstrap-icons';

const SendOmLetterView = () => {
  const {
    loading,
    error,
    successMsg,
    reportEmails,
    omLetterEmails,
    handleReportXlsxChange,
    handleOmLetterXlsxChange,
    handleSendPatientsReports,
    handleSendOmLetter,
    handleReportEmailsChange,
    handleOmLetterEmailsChange,
    handleCloseError,
    reportFileInput,
    omLetterFileInput,
    omLetterFileName,
    reportFileName,
    handleClearSuccessMessage,
    handleClickOmLetterFile,
    handleClickReportFile,
  } = useSendOmLetter();

  return (
    <Container className='mt-3'>
      {loading ? (<LoadingSpinner />) : null}
      <Row>
        <Col sm={12} lg={12} md={12} className='mt-3'>
          <Card>
            <Card.Header className='text-center'>
              <h5 className='title-module'>Módulo Reporte de pacientes: Consentimiento, Carta de resguardo y Orden médica</h5>
            </Card.Header>
            <Card.Body>
              <Row className='mt-4'>
                <Col sm={12} lg={12} md={12} className=''>
                    <div className='d-flex'>
                        <Form.Label className='mb-3 title-physical-exams mt-3'>Subir archivo XLSX con RUTs de pacientes a verificar: </Form.Label>
                        <Button
                            id='btn-upload-report-file'
                            onClick={ handleClickReportFile }
                            className='btn-upload-file'
                        >
                            <Upload />
                            <p>Cargar Excel</p>
                        </Button>
                        <Form.Control 
                            type='file'
                            name='file'
                            ref={reportFileInput}
                            onChange={handleReportXlsxChange}
                            style={{display:'none'}} 
                        />
                        <div 
                          className={`file-name-box ${reportFileName ? 'file-selected' : 'placeholder'}`}
                        >
                          {reportFileName ? reportFileName : 'Seleccione un archivo'}
                        </div>
                    </div>
                </Col>
              </Row>
              <Row className='mt-2'>
                  <Col sm={6} lg={6} md={6}>
                      <EmailInput 
                          handleEmailsChange={handleReportEmailsChange}
                          emails={reportEmails}
                          title='¿A quienes se enviarán los reportes?'
                      />
                  </Col>
              </Row>
              <Row className='mt-4'>
                <Col sm={6} lg={6} md={6}>
                  <Button 
                    variant='primary' 
                    onClick={handleSendPatientsReports}
                    disabled= {reportEmails.length === 0 ||  reportFileName === null}>
                    Generar
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col sm={12} lg={12} md={12} className='mt-4'>
          <Card>
            <Card.Header className='text-center'>
              <h5 className='title-module'>Módulo Enviar Carta de resguardo y Orden médica a pacientes</h5>
            </Card.Header>
            <Card.Body>
              <Row className='mt-4'>
                <Col sm={12} lg={12} md={12} className=''>
                    <div className='d-flex'>
                        <Form.Label className='mb-3 title-physical-exams mt-3'>Subir archivo XLSX con RUTs de pacientes a verificar: </Form.Label>
                        <Button
                            id='btn-upload-report-file'
                            onClick={ handleClickOmLetterFile }
                            className='btn-upload-file'
                        >
                            <Upload />
                            <p>Cargar Excel</p>
                        </Button>
                        <Form.Control
                            type='file'
                            name='file'
                            ref={omLetterFileInput}
                            onChange={handleOmLetterXlsxChange}
                            style={{display:'none'}}
                        />
                        <div 
                          className={`file-name-box ${omLetterFileName ? 'file-selected' : 'placeholder'}`}
                        >
                          {omLetterFileName ? omLetterFileName : 'Seleccione un archivo'}
                        </div>
                    </div>
                </Col>
              </Row>
              <Row className='mt-2'>
                  <Col sm={6} lg={6} md={6}>
                      <EmailInput 
                          handleEmailsChange={handleOmLetterEmailsChange}
                          emails={omLetterEmails}
                          title='¿A quienes se le enviará un estado de los pacientes ?'
                      />
                  </Col>
              </Row>
              <Row className='mt-4'>
                <Col sm={6} lg={6} md={6}>
                  <Button 
                    variant='primary' 
                    onClick={handleSendOmLetter}
                    disabled={omLetterEmails.length === 0 ||  omLetterFileName === null}>
                    Generar
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        {error && (
          <ErrorDialog
            show={true}
            handleClose={handleCloseError}
            title='Error al enviar reporte'
            message={error}
          />
        )}
        {successMsg && (
          <SuccessDialog
            show={true}
            handleClose={handleClearSuccessMessage}
            title='Reporte enviado'
            message={successMsg}
          />
        )}
      </Row>
    </Container>
  );
}

export default SendOmLetterView;